import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../../constants';
import { formatAmount } from '../../../../utils/index';

import SvgComponent from '../../../SvgComponent';
import CashbackByStatusComponent from './CashbackByStatusComponent';

class ResumeCashbackComponent extends React.Component {
    render() {
        const {
            i18n,
            totalCashback,
            cssClassLeft,
            leftAmount,
            cssClassRight,
            rightAmount
        } = this.props;

        return (
            <div className="resumeCagnotte">
                <div className="totalCagnotte">
                    {i18n.JACKPOT}
                    <span> {formatAmount(totalCashback)}</span>
                </div>
                <CashbackByStatusComponent
                    cssClass={cssClassLeft}
                    amount={leftAmount}
                    txt={i18n.VALID_CASHBACK}
                />
                <div className="croixResumeCagnotte">
                    <SvgComponent
                        src={`${STATIC_ROOT}/compte/mes-achats/croix.svg`}
                        width="41"
                        height="41"
                    />
                </div>
                <CashbackByStatusComponent
                    cssClass={cssClassRight}
                    amount={rightAmount}
                    txt={i18n.WAITING_CASHBACK}
                />
            </div>
        );
    }
}

ResumeCashbackComponent.propTypes = {
    totalCashback: PropTypes.number.isRequired,
    leftAmount: PropTypes.number.isRequired,
    rightAmount: PropTypes.number.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT
    };
}

export default connect(mapStateToProps)(ResumeCashbackComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/ResumeCashbackComponent.js